module.exports = __webpack_public_path__ + "static/media/Handa_UnregelApp.3a5de103.jpg";